import type { WsMessage } from "@/api/websocket";
import type { FrameApplyContext } from "@/lib/companion-frame-reducer";
import { applyWorkToastExecutionEvent } from "@/lib/work-toast-execution-events";
import { applyWorkToastNotificationEvent } from "@/lib/work-toast-notification-events";

/** Feeds one companion frame to the work toast store. Runs in every window inside
 *  the frame's mutation-suppressed apply, so pruning here never emits mirror mutations. */
export function applyWorkToastFrame(message: WsMessage, ctx: FrameApplyContext): void {
  const now = Date.now();
  ctx.workToastStore.getState().pruneTerminal(now);
  if (applyWorkToastExecutionEvent(message, ctx, now)) return;
  applyWorkToastNotificationEvent(message, ctx, now);
}
